import { ReactNode, useMemo } from 'react'

import { Heading4, Paragraph } from 'src/components/atoms/Typography'

export enum InformationBlockImage {
  Individual = 'Individual',
  Business = 'Business'
}

export type InformationBlockProps = {
  image: InformationBlockImage
  heading: string
  description: string
  buttons: ReactNode | ReactNode[]
}

const InformationBlock = ({
  image,
  heading,
  description,
  buttons
}: InformationBlockProps) => {
  const imageClasses = useMemo(() => {
    switch (image) {
      case InformationBlockImage.Business:
        return `bg-[url("/img/business.svg")] bg-size-[140%] bg-center`
      case InformationBlockImage.Individual:
        return 'bg-[url("/img/individuals.svg")] bg-size-[100%] bg-position-[center_-60px]'
      default:
        return ''
    }
  }, [image])

  return (
    <div className='bg-white flex flex-1 flex-col'>
      <div className={`bg-no-repeat h-40 ${imageClasses}`} />
      <div className='p-5 md:p-10 pt-5!'>
        <Heading4 className='font-bold! md:text-[28px]! text-[20px]!'>
          {heading}
        </Heading4>
        <Paragraph>{description}</Paragraph>
        <div className='flex flex-col md:flex-row space-y-5 md:space-y-0 md:space-x-5 mt-5'>
          {buttons}
        </div>
      </div>
    </div>
  )
}

export default InformationBlock
